import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { onboardingEmail as orgConfig } from 'org/configs/modules.config';

/** @type {object} */
const defaultConfig = {
  defaults: {
    shouldOptInBeCheckedByDefault: true,
    optInHeadingText: 'Get the best deals right in your inbox',
    getOptInText: (earnType) => (`Don't hunt for sales or extra ${earnType} offers. We'll email them to you.`),
    labelText: 'Yes, email me about deals',
    getEmailDisclaimerText: () => '',
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
